import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { fontSize, lineHeight, fontFamily } = typographyStyles;
const {
  colors: { ui },
  breakpoints: { BreakpointNames },
} = constants;
const { mediaQuery } = mediaQueryStyles;

export const standardsSetRowCss: CSSObject = {
  padding: "12px 32px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  borderBottom: `1px solid ${ui.neutral[100]}`,
};

export const standardInfoCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  height: "100%",
  ...fontFamily.circular,
  maxWidth: "82%",

  [mediaQuery.upTo(BreakpointNames.md)]: {
    maxWidth: "75%",
  },
  [mediaQuery.upTo(BreakpointNames.sm)]: {
    maxWidth: "64%",
  },
  [mediaQuery.upTo(BreakpointNames.xs)]: {
    maxWidth: "50%",
  },
};

export const standardGradesAndYearCss: CSSObject = {
  display: "block",
  ...fontSize.textXS,
  fontWeight: 700,
  color: ui.neutral[600],
  lineHeight: "14px",
};

export const standardSubjectCss: CSSObject = {
  display: "block",
  ...fontSize.textM,
  fontWeight: 700,
  color: ui.neutral[700],
  ...lineHeight.l16,
};

export const standardRegionAndTitleCss: CSSObject = {
  display: "block",
  ...fontSize.textXS,
  fontWeight: 400,
  color: ui.neutral[600],
  ...lineHeight.l16,
};
